<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <section class="chat-application">
      <section class="user-chats">
        <section class="chat-app-window">
          <div
            v-if="chatData !== null"
            class="active-chat"
            :style="`height: ${height}px`"
          >
            <div class="chat-navbar">
              <header class="chat-header">
                <!-- Avatar & Name -->
                <div class="d-flex align-items-center">
                  <!--                                 Toggle Icon -->
                  <b-avatar
                    size="36"
                    :src="chatData.User.Image"
                    class="mr-1 cursor-pointer badge-minimal"
                    :to="{name:'userDetail' , params:{id:chatData.User.Id}}"
                    target="_blank"
                  />
                  <h6 class="mb-0">
                    <template v-if="chatData.User.Name || chatData.User.Family">
                      {{ chatData.User.Name }} {{ chatData.User.Family }}
                    </template>
                    <template v-else>
                      کاربر زیره
                    </template>
                  </h6>
                </div>
                <b-row
                  align-v="center"
                  align-content="center"
                >
                  <b-col>
                    <b-row>
                      <b-col md="12">
                        <span class="mr-1 ticketTitleKsy"> عنوان </span>
                        <b-badge
                          v-if="ticketInfo.Title.length > 20"
                          v-b-tooltip.hover
                          variant="light-primary"
                          :title="ticketInfo.Title"
                        >
                          {{ ticketInfo.Title.substring( 0, 20 ) + ' ...' }}
                        </b-badge>
                        <b-badge
                          v-else
                          variant="light-primary"
                        >
                          {{ ticketInfo.Title }}
                        </b-badge>
                      </b-col>
                      <b-col
                        md="12"
                        style="margin-top:5px"
                      >
                        <span class="mr-1 ticketTitleKsy">  وضعیت </span>
                        <div class="dropdown d-inline-block">
                          <b-dropdown
                            variant="link"
                            no-caret
                            toggle-class="p-0"
                            right
                          >
                            <template #button-content>
                              <b-badge
                                pill
                                :variant="`light-${enums('TicketStatus', 'value', ticketInfo.Status, 'badge')}`"
                              >
                                {{ enums('TicketStatus', 'value', ticketInfo.Status , 'text') }}
                                <feather-icon icon="EditIcon" />
                              </b-badge>
                            </template>
                            <template
                              v-for="status in enums('TicketStatus')"
                            >
                              <b-dropdown-item @click="changeStatus">
                                {{ status.text }}
                              </b-dropdown-item>
                            </template>
                          </b-dropdown>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col>
                    <b-row>
                      <b-col md="12">
                        <span class="mr-1 ticketTitleKsy">
                          دپارتمان
                        </span>
                        <departmentList
                          v-model="ticketInfo.TicketDepartmentId"
                          :drop-down="true"
                          :multiple="false"
                        >
                          <feather-icon icon="EditIcon" />
                        </departmentList>
                      </b-col>
                      <b-col
                        md="12"
                        style="margin-top:5px"
                      >
                        <span class="mr-1 ticketTitleKsy">تاریخ ایجاد</span>
                        <b-badge variant="light-primary">
                          {{ ticketInfo.CreatedAt | date }}
                        </b-badge>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row
                  align-v="center"
                  align-content="center"
                >
                  <b-button
                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                    variant="outline-secondary"
                    @click="back"
                  >
                    بازگشت
                  </b-button>
                </b-row>
              </header>
            </div>
            <vue-perfect-scrollbar
              ref="scrollbar"
              :settings="{maxScrollbarLength: 150}"
              class="user-chats scroll-area"
              @ps-y-reach-start="updateLog($event)"
            >
              <div
                v-for="(msgGrp, index) in chatLogs"
                :key="msgGrp.Id+String(index)"
              >
                <div
                  v-if="showTime(index)"
                  class="timeBox"
                >
                  <div class="messageDate">
                    <span>{{ msgGrp.CreatedAt | date }}</span>
                  </div>
                </div>
                <div class="chats">
                  <div
                    class="chat"
                    :class="{'chat-left': msgGrp.User.Id === chatData.User.Id}"
                  >

                    <div class="chat-avatar">
                      <b-avatar
                        size="36"
                        class="avatar-border-2 box-shadow-1"
                        variant="transparent"
                        :src="msgGrp.User.Id === chatData.User.Id ? chatData.User.Image : msgGrp.User.Image"
                      />
                    </div>
                    <div class="chat-body">
                      <div
                        :class="!msgGrp.Visibility? 'chat-content-disable': 'chat-content' "
                      >
                        <span
                          v-if="msgGrp.User.Id !== chatData.User.Id"
                          class="ticketMeta"
                        >{{ msgGrp.User.Name + ' ' + msgGrp.User.Family }}</span>
                        <span
                          style="float:left"
                          class="ml-1"
                        >
                          <feather-icon
                            v-if="msgGrp.User.Id !== chatData.User.Id"
                            v-b-tooltip.hover
                            :icon="msgGrp.Visibility ? 'EyeIcon':'EyeOffIcon' "
                            title="عدم نمایش به کاربر"
                            @click="removeMessage(msgGrp.Id)"
                          />
                        </span>
                        <p
                          class="my-1"
                          v-html="messageEnter(msgGrp.Description)"
                        />
                        <div
                          v-if="msgGrp.TicketAttachment !== null"
                          class="viewFile"
                        >
                          <a
                            :href="msgGrp.TicketAttachment.Url"
                            target="_blank"
                          >
                            <feather-icon
                              v-b-tooltip.hover
                              icon="EyeIcon"
                              size="20"
                              :color="msgGrp.User.Id !== chatData.User.Id?'white':'info'"
                              title="نمایش فایل در سایز بزرگ"
                            />
                          </a>
                          <div
                            style="
                              display: flex;
                              justify-content: space-between;
                              width: 100%;
                              margin-left: 5px;
                            "
                          >
                            <span style="order: 1;direction:ltr">{{ msgGrp.TicketAttachment.FileName.split('.')[0].substring(0,20) }} </span>
                            <span>{{ msgGrp.TicketAttachment.FileName.split('.').pop() }}</span>
                          </div>
                          <feather-icon
                            icon="FileIcon"
                            size="20"
                          />
                        </div>
                        <div
                          v-if="msgGrp.TicketAttachment !== null"
                          class="mt-1"
                        >
                          <b-img
                            v-if="isImage(msgGrp.TicketAttachment.FileName)"
                            center
                            rounded
                            thumbnail
                            fluid
                            :src="msgGrp.TicketAttachment.Url"
                            width="250"
                          />
                          <video
                            v-if="isVideo(msgGrp.TicketAttachment.FileName)"
                            width="250"
                            :src="msgGrp.TicketAttachment.Url"
                            controls
                            style="display: block;margin: auto"
                          />
                        </div>
                        <div class="messageTime">
                          <small class="mail-date-time text-muted">{{ (new Date(msgGrp.CreatedAt).toLocaleTimeString('en-GB')) | time }}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </vue-perfect-scrollbar>
          </div>
          <div class="d-flex flex-row justify-content-between mt-1">
            <div class="flex-grow-1">
              <b-form-textarea
                v-model="form.ticketInputMessage"
                placeholder="متن پاسخ به تیکت"
                rows="3"
                max-rows="8"
                style="overflow: auto;"
              /></div>
            <Div class="d-flex flex-column">
              <div class="d-flex flex-row justify-content-between ml-1">
                <div
                  class="m-1 btn-send-message"
                  style="position:relative;"
                >
                  <twemoji-picker
                    :emoji-data="emojiDataAll"
                    :emoji-groups="emojiGroups"
                    :skins-selection="false"
                    :search-emojis-feat="true"
                    search-emoji-placeholder="جسست و جو ایموجی"
                    search-emoji-not-found="ایموجی پیدا نشد"
                    is-loading-label="بارگزاری ..."
                    :picker-width="500"
                    @click.native=" $event.preventDefault()"
                    @emojiUnicodeAdded="form.ticketInputMessage += $event"
                  >
                    <template v-slot:twemoji-picker-button>
                      <feather-icon
                        icon="SmileIcon"
                        class="cursor-pointer hover-Attach"
                        size="25"
                      />
                    </template>
                  </twemoji-picker></div>
                <div
                  class="btn-send-message"
                >  <div>
                  <label for="upload">
                    <feather-icon
                      icon="PaperclipIcon"
                      class="cursor-pointer hover-Attach"
                      size="25"
                    />
                    <input
                      id="upload"
                      ref="inputFile"
                      type="file"
                      style="display:none"
                      @input="onFileChange"
                    >
                  </label>
                </div></div>
                <div class="btn-send-message"  v-if="activeAudioRecorder">
                               <audioRecorder @preview="preview = $event" @file ="form.uploadFile = $event"></audioRecorder>
                </div>
                <div class="btn-send-message"
                     v-if="!activeAudioRecorder"
                     style="width: 60px;height: 53px;text-align: center;"
                >
                  <span>
                     <img @click="unlockRecord"
                          style="width: 25px; height: 25px; cursor: pointer"
                          :src="require('@/assets/images/icons/lockMic.png')">
                  </span>

                </div>
                <div
                  class="btn-send-message"
                > <b-button
                  variant="primary"
                  :disabled="form.ticketInputMessage==='' && form.uploadFile === null "
                  @click="triggerSendMessage"
                >
                  ارسال
                </b-button></div>
              </div>
              <div
                v-if="form.uploadFile !== null"
                class="ml-1 d-flex px-1 cursor-pointer hover-Attach"
                is-text
                style=" height: 40px;
                 border: 1px solid #e1e0e9;
                border-radius: 10px"
                @mouseenter="uploadFileActions = true"
                @mouseleave="uploadFileActions = false"
              >
                <div class="mr-1 d-flex flex-column justify-content-around">
                  <div
                    v-if="uploadFileActions"
                    class="d-flex flex-column"
                  >
                    <div>
                      <feather-icon
                        v-b-tooltip.hover
                        icon="Trash2Icon"
                        class="cursor-pointer trashHover"
                        title="حذف فایل"
                        @click="form.uploadFile = null"
                      />
                    </div>
                    <div>
                      <a
                        :href="preview"
                        target="_blank"
                      >
                        <feather-icon
                          v-b-tooltip.hover
                          icon="EyeIcon"
                          class="cursor-pointer"
                          title="نمایش فایل"
                        />
                      </a>
                    </div>
                  </div>
                  <feather-icon
                    v-else
                    dir="ltr"
                    icon="FileIcon"
                    class="cursor-pointer"
                  />
                </div>
                <div class="d-flex flex-column justify-content-around">
                  <p style="margin: 0">
                    {{ form.uploadFile.name }}
                  </p>
                </div>
              </div>
            </Div>
          </div>
        </section>
      </section>
    </section>
  </b-overlay>
</template>

<script>
import { BAvatar } from 'bootstrap-vue'

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import departmentList from '@/tools/departmentList.vue'
import {
  TwemojiPicker,
} from '@kevinfaguiar/vue-twemoji-picker'
import EmojiAllData from '@kevinfaguiar/vue-twemoji-picker/emoji-data/en/emoji-all-groups.json'
import EmojiGroups from '@kevinfaguiar/vue-twemoji-picker/emoji-data/emoji-groups.json'
import audioRecorder from '@/views/menu/ticket/audioRecorder'
export default {
  name: 'TicketReply',
  components: {
    BAvatar,
    VuePerfectScrollbar,
    departmentList,
    'twemoji-picker': TwemojiPicker,
    audioRecorder
  },
  data() {
    return {
      activeAudioRecorder: false,
      preview: null,
      type: 'image',
      department: 1,
      chatData: null,
      profileUserAvatar: {},
      height: null,
      activeEvent: false,
      filterOptions: {
        Id: null,
        Page: 1,
        PerPage: 50,
      },
      wait: false,
      loading: false,
      form: {
        ticketInputMessage: '',
        uploadFile: null,
      },
      userData: null,
      uploadFileActions: false,
      trashIconHover: false,
      ticketInfo: {
        Title: null,
        Id: null,
        TicketDepartmentId: null,
        Status: null,
        CreatedAt: null,
      },
    }
  },
  computed: {
    chatLogs() {
      return this.chatData.TicketDetails.slice().reverse()
    },
    emojiDataAll() {
      return EmojiAllData
    },
    emojiGroups() {
      return EmojiGroups
    },
  },
  created() {
    this.height = window.innerHeight - 250
    this.userData = JSON.parse(localStorage.getItem('userData'))
    this.profileUserAvatar = this.userData.Image
    this.latestChatLog()
  },
  methods: {
    unlockRecord(){
      this.activeAudioRecorder = true
    },
    messageEnter(msgGrp) {
      if (msgGrp) {
        return msgGrp.replaceAll('\n', '<br>')
      }

      return msgGrp
    },
    removeMessage(messageId) {
      this.chatLogs.forEach(log => {
        if (log.Id === messageId) log.Visibility = !log.Visibility
      })
      this.$http.post(
        this.$api.ticket.changeVisibility, {
          TicketDetailsId: messageId,
        },
      ).then(() => {

      })
    },
    isImage(str) {
      const regex = /.*\.(gif|jpe?g|bmp|png)$/igm
      const test = str.search(regex)
      return test !== -1
    },
    isVideo(str) {
      const regex = /\.(mp4|ogv|avi|flv|wmv|mov|mp3|mp([1-4]|e?g)|ts(.?)|3gp|m(o|4)(a|v)|og(a|g|v)|a(vi|ac))$/gi
      const test = str.search(regex)
      return test !== -1
    },
    changeStatus(e) {
      this.ticketInfo.Status = this.enums('TicketStatus', 'text', e.target.innerText, 'value')
    },
    updateTicketInfo() {
      this.loading = true
      this.$http.post(this.$api.ticket.update, this.ticketInfo).then(() => { this.loading = false })
    },
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.form.uploadFile = files[0]
      // const fileReader = new FileReader()
      // fileReader.readAsDataURL(files[0])

      // fileReader.onload = () => {
      //     this.preview =  fileReader.result
      // }
      this.preview = URL.createObjectURL(files[0])
      e.target.value = null
    },
    setTicketInfo() {
      this.ticketInfo = {
        Title: this.chatData.Title,
        Id: this.chatData.Id,
        Status: this.chatData.Status,
        TicketDepartmentId: this.chatData.TicketDepartment.Id,
        CreatedAt: this.chatData.CreatedAt,
      }
    },
    latestChatLog() {
      this.filterOptions.Id = this.$route.params.id
      this.filterOptions.Page = 1
      this.chatLog().then(res => {
        this.chatData = res.data
        this.scrollToBottom()
        this.setTicketInfo()
        this.$watch('ticketInfo', () => {
          this.updateTicketInfo()
        }, {
          deep: true,
        })
      })
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const scrollEl = this.$refs.scrollbar.$el
        scrollEl.scrollTop = scrollEl.scrollHeight
        this.activeEvent = true
      })
    },
    chatLog() {
      return new Promise(resolve => {
        this.loading = true
        this.$http.post(
          this.$api.ticket.get, this.filterOptions,
        ).then(res => {
          this.loading = false
          resolve(res)
        })
      })
    },
    updateLog() {
      if (this.activeEvent === true && this.wait == false) {
        this.wait = true
        this.filterOptions.Page += 1
        this.chatLog().then(res => {
          this.wait = false
          if (res.data.TicketDetails.length !== 0) {
            this.activeEvent = false
            const scrollEl = this.$refs.scrollbar.$el
            this.chatData.TicketDetails.push(...res.data.TicketDetails)
            this.$refs.scrollbar.$el.scrollTop = scrollEl.scrollHeight / this.filterOptions.Page + 1
            this.activeEvent = true
          } else {
            this.activeEvent = false
          }
        })
      }
    },
    sendMessage(FormData) {
      return new Promise(resolve => {
        this.loading = true
        this.$http.post(
          this.$api.ticket.reply, FormData,
        ).then(res => {
          this.loading = false
          resolve(res.data)
        })
      })
    },
    triggerSendMessage(e) {
      e.preventDefault()
      const file = new FormData()
      file.append('Id', this.filterOptions.Id)
      file.append('Description', this.form.ticketInputMessage)
      file.append('TicketAttachment', this.form.uploadFile)
      this.sendMessage(file).then(res => {
        this.activeEvent = false
        const newMessage = {
          CreatedAt: this.$moment().toJSON(),
          Description: this.form.ticketInputMessage,
          Id: res.TicketDetailsId,
          TicketAttachment: null,
          Visibility: true,
          User: {
            Id: 27, Name: this.userData.Name, Family: this.userData.Family, Image: this.userData.Image,
          },
        }
        if (this.form.uploadFile !== null) {
          newMessage.TicketAttachment = {
            FileName: this.form.uploadFile.name,
            Url: this.preview,
          }
        }
        this.chatData.TicketDetails.unshift(newMessage)
        this.scrollToBottom()
        this.form.uploadFile = null
        this.form.ticketInputMessage = null
      })
    },
    showTime(index) {
      if (index !== 0) {
        return (this.chatLogs[index].CreatedAt.substring(0, 10) !== this.chatLogs[index - 1].CreatedAt.substring(0, 10))
      } return true
    },
  },
}
</script>

<style lang="scss">
    @import "@core/scss/base/pages/app-chat-list.scss";
    @import "@core/scss/base/pages/app-chat.scss";
    .scroll-area {
      position: relative;
      height: 300px;
    }
    .timeBox{
        display: flex;
        justify-content:space-around;
    }
    .messageDate {
        box-sizing: border-box;
        display: inline-block;
        flex: none;
        max-width: 100%!important;
        font-size: 12.5px;
        line-height: 21px;
        color: $primary;
        padding: 5px 12px 6px;
        text-align: center;
        text-shadow: 0 1px 0 rgba(black,.4);
        background-color:  #e1e0e9;
        border-radius: 7.5px;
        box-shadow: 0 1px .5px rgba(#e1e0e9,.13);
        text-align: center;
    }
    .messageTime {
        height: 15px;
        font-size: 10px;
        line-height: 15px;
        white-space: nowrap;
        margin-top: 5px;
    }
    .viewFile {
      display: flex;
        border: 1px solid $white;
        padding: 5px;
        margin-top: 5px;
        border-radius: 10px;
        &:hover{
            box-shadow: 0 8px 25px -8px $primary;
        }
        a{
            width: 50px;
            display: block;
            text-align: center;
            margin-right: auto;
        }
        p{
            span{
                margin-right: 15px !important;
            }
        }
    }
    .hover-Attach:hover{
        color :$primary;
    }
    .trashHover:hover{
        color : $primary;
        /*background-color : #7367f0*/
    }
    .ticketMeta{
        font-size: 10px;
        opacity: 0.8;
    }
    .ticketTitleKsy{
        font-size: 11px;
        opacity: 0.8;
    }
    #arrow{
        right: 22px !important;
        transform: translate(-15px, -2px) !important;
    }
    #popper-container{
        transform: translate(13px, -40px) !important;
    }
    .chat-app-window {
        // User chats
        .user-chats {
            height: calc(100% - 65px) !important;
        }
    }
    .btn-send-message{
      display: flex;
      flex-flow: column;
      justify-content: center;
      margin-left: 5px;
    }
    //change audio recorder btn style
    .vue-audio-recorder{
      background-color: transparent ;
      width: 60px;
      height: 53px;
      &:before{
        background-color: $secondary;
      }
      &:after{
        background-color:$secondary
      }
      span {
        &:before {
          background-color: $secondary;
          border: 0.125em solid $secondary;
        }
        &:after {
          background-color: $secondary;
        }
      }
      // hover status
      &:hover:after{
        background-color: $primary
      }
      &:hover:before{
        background-color: $primary;
      }
      &:hover span {
        &:before {
          background-color:$primary;
          border: 0.125em solid $primary;
        }
        &:after {
          background-color:$primary;
        }
      }
    }
</style>
